import { httpRequest } from "../Network";

export const getClaimRequestOnFoundItem = (itemId: string) => {
    return httpRequest('GET', `/aggregation/admin/claim-request-on-found-item/${itemId}`)
      .then((response: any) => response.data)
      .catch((error) => {
        throw error;
      });
  };
  